import { BADGE_VARIANTS } from 'components/Badge'
import { NAVIGATION_STATUSES } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const NAVIGATION_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [NAVIGATION_STATUSES.PUBLISHED]: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Published',
  },
  [NAVIGATION_STATUSES.NOT_PUBLISHED]: {
    variant: BADGE_VARIANTS.GRAY,
    text: 'Draft',
  },
}
